import { render, staticRenderFns } from "./cardUsers.vue?vue&type=template&id=1067dcd0&scoped=true&"
import script from "./cardUsers.vue?vue&type=script&lang=js&"
export * from "./cardUsers.vue?vue&type=script&lang=js&"
import style0 from "./cardUsers.vue?vue&type=style&index=0&id=1067dcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067dcd0",
  null
  
)

export default component.exports